import MiniModal from './mini-modal';
export default new MiniModal();
